import { user } from 'common/middleware/api';
import { injectError } from 'common/redux/actions/error';
import { ApiError } from 'common/modules/api';
import { FetchTypeEnum } from 'common/enums/FetchEnum';
import TeamUtils from 'common/utils/TeamUtils';

export default class UserActions {
    static FETCH_USER_SUCCESS = 'FETCH_USER_SUCCESS';
    static FETCH_USER_ERROR = 'FETCH_USER_ERROR';
    static FETCH_USER_REQUEST = 'FETCH_USER_REQUEST';
    static FETCH_USER_END = 'FETCH_USER_END';
    static UPDATE_USER = 'UPDATE_USER';

    static pollUsersByClientId = (...params) => {
        return dispatch => {
            return new Promise((resolve, reject) => {
                dispatch(
                    UserActions.fetchUsersByClientId(...params, {
                        onSuccess: resolve,
                        onFailure: reject
                    })
                );
            });
        };
    };
    static fetchUsersByClientId = (
        clientId,
        formattedDate,
        shiftId,
        teamIds,
        fetchType,
        { onSuccess, onFailure } = {}
    ) => {
        return dispatch => {
            if (TeamUtils.hasNoTeam(teamIds)) {
                return;
            }
            const params = { clientId };
            if (formattedDate) {
                params.date = formattedDate;
            }
            if (shiftId) {
                params.shift = shiftId;
            }
            if (formattedDate && shiftId) {
                params.include = 'EVENTS,TASKS_COUNT';
            }
            if (teamIds && teamIds.length) {
                params.team = teamIds;
            }
            if (fetchType === FetchTypeEnum.Initial) {
                dispatch(UserActions.setUsersLoading(clientId));
            }
            return user
                .fetch(params)
                .then(data => {
                    onSuccess?.(data);
                    if (fetchType === FetchTypeEnum.Initial) {
                        dispatch(UserActions.setUsersLoadingEnd(clientId));
                    }
                    dispatch(UserActions.injectUsers(data, clientId));
                    return;
                })
                .catch(error => {
                    onFailure?.(error);
                    if (error instanceof ApiError) {
                        dispatch(UserActions.setUsersLoadingError(clientId));
                        dispatch(injectError(error));
                        return;
                    }
                    throw error;
                });
        };
    };

    static injectUsers = (users, clientId) => {
        return {
            type: UserActions.FETCH_USER_SUCCESS,
            response: users,
            clientId
        };
    };

    static setUsersLoading = clientId => {
        return {
            type: UserActions.FETCH_USER_REQUEST,
            clientId
        };
    };

    static setUsersLoadingError = clientId => {
        return {
            type: UserActions.FETCH_USER_ERROR,
            clientId
        };
    };

    static setUsersLoadingEnd = clientId => {
        return {
            type: UserActions.FETCH_USER_END,
            clientId
        };
    };

    static updateUser = (user, clientId) => {
        return {
            type: UserActions.UPDATE_USER,
            response: user,
            clientId
        };
    };
}

export { UserActions };
